import AdminLayout from '../../components/feature/AdminLayout';
import DemoTenantsTable from '../demo-tenants/components/DemoTenantsTable';

export default function ExpiredDemoTenantsPage() {
  return (
    <AdminLayout>
      <DemoTenantsTable mode="expired" />
    </AdminLayout>
  );
}
